import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchModules = () => api.get("/modules").then((r) => r.data);
export const fetchModule = (id) => api.get(`/modules/${id}`).then((r) => r.data);
export const fetchRecords = (module) =>
  api.get("/records", { params: { module } }).then((r) => r.data);
export const createRecord = (module, data) =>
  api.post("/records", { module, data }).then((r) => r.data);
export const updateRecord = (id, data) =>
  api.put(`/records/${id}`, { data }).then((r) => r.data);
export const deleteRecord = (id) => api.delete(`/records/${id}`).then((r) => r.data);
export const clearModule = (module) =>
  api.delete("/records", { params: { module } }).then((r) => r.data);
export const uploadExcel = (moduleId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(`/upload/${moduleId}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const fetchSummary = () => api.get("/summary").then((r) => r.data);
export const exportUrl = (moduleId, format = "xlsx") =>
  `${API}/export/${moduleId}?format=${format}`;

// Attachments
export const listAttachments = (recordId) =>
  api.get(`/records/${recordId}/attachments`).then((r) => r.data);

export const uploadAttachment = (recordId, file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post(`/records/${recordId}/attachments`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total)
          onProgress(Math.round((e.loaded / e.total) * 100));
      },
    })
    .then((r) => r.data);
};

export const deleteAttachment = (recordId, attachmentId) =>
  api.delete(`/records/${recordId}/attachments/${attachmentId}`).then((r) => r.data);

export const attachmentUrl = (storagePath) => `${API}/attachments/${storagePath}`;

// AI Report history
export const listReports = (recordId) =>
  api.get(`/records/${recordId}/reports`).then((r) => r.data);
export const saveReport = (recordId, content, photoCount) =>
  api
    .post(`/records/${recordId}/reports`, { content, photo_count: photoCount })
    .then((r) => r.data);
export const deleteReport = (recordId, reportId) =>
  api.delete(`/records/${recordId}/reports/${reportId}`).then((r) => r.data);

// Email recipients & schedule
export const listRecipients = (module) =>
  api.get("/recipients", { params: { module } }).then((r) => r.data);
export const createRecipient = (module, payload) =>
  api.post("/recipients", { module, ...payload }).then((r) => r.data);
export const updateRecipient = (id, role) =>
  api.patch(`/recipients/${id}`, { role }).then((r) => r.data);
export const deleteRecipient = (id) =>
  api.delete(`/recipients/${id}`).then((r) => r.data);
export const getSchedule = (module) =>
  api.get(`/schedules/${module}`).then((r) => r.data);
export const updateSchedule = (module, cfg) =>
  api.put(`/schedules/${module}`, { module, ...cfg }).then((r) => r.data);
// Twilio config + WA logs + opt-in
export const sendAnalysis = (module, content, subject) =>
  api
    .post("/send-analysis", { module, content, subject })
    .then((r) => r.data);
export const getTwilioConfig = () =>
  api.get("/twilio/config").then((r) => r.data);
export const updateTwilioConfig = (payload) =>
  api.put("/twilio/config", payload).then((r) => r.data);
export const sendOptin = (phone, sandbox_code) =>
  api.post("/twilio/send-optin", { phone, sandbox_code }).then((r) => r.data);
export const listWaLogs = (module) =>
  api.get("/wa-logs", { params: { module } }).then((r) => r.data);
